import { useEffect, useRef, useState } from "react";

const PRESETS = [1, 2, 4, 6, 8, 10];

export default function CountInput({
  value,
  onChange,
  allPreset,
}: {
  value: number | null;
  onChange: (value: number | null) => void;
  allPreset?: number;
}) {
  // Local string state so the field can be empty mid-typing without losing focus.
  const [raw, setRaw] = useState(value === null ? "" : String(value));
  const inputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    inputRef.current?.focus();
    inputRef.current?.select();
  }, []);

  const setFromText = (text: string) => {
    const digits = text.replace(/\D/g, "").slice(0, 3);
    setRaw(digits);
    const n = Number(digits);
    onChange(digits && n >= 1 ? n : null);
  };

  const setFromPreset = (n: number) => {
    setRaw(String(n));
    onChange(n);
  };

  return (
    <div className="flex flex-col items-center gap-5">
      <div className="text-center">
        <input
          ref={inputRef}
          type="text"
          inputMode="numeric"
          placeholder="0"
          value={raw}
          onChange={(e) => setFromText(e.target.value)}
          onFocus={(e) => e.target.select()}
          aria-label="Number of boxes"
          className="h-36 w-64 rounded-[18px] bg-white text-center text-8xl font-bold outline-none placeholder:text-ink/20 border border-line focus:border-[#e39aa8] focus:ring-[3px] focus:ring-rose/20"
        />
        <div className="mt-2 text-sm font-semibold text-ink/60">
          {value === 1 ? "box" : "boxes"}
        </div>
      </div>
      <div className="flex flex-wrap justify-center gap-2">
        {PRESETS.map((preset) => (
          <button
            key={preset}
            onClick={() => setFromPreset(preset)}
            className={`min-w-11 rounded-full px-4 py-2 text-sm font-bold shadow-sm transition-colors ${
              value === preset ? "bg-ink text-white" : "bg-white"
            }`}
          >
            {preset}
          </button>
        ))}
        {allPreset && allPreset > 0 && (
          <button
            onClick={() => setFromPreset(Math.min(allPreset, 999))}
            className={`rounded-full px-4 py-2 text-sm font-bold shadow-sm ${
              value === allPreset ? "bg-ink text-white" : "bg-blush text-rose-ink"
            }`}
          >
            All ({allPreset})
          </button>
        )}
      </div>
    </div>
  );
}
